import { render, staticRenderFns } from "./ConventionList.vue?vue&type=template&id=039db22a&scoped=true"
import script from "./ConventionList.vue?vue&type=script&lang=js"
export * from "./ConventionList.vue?vue&type=script&lang=js"
import style0 from "./ConventionList.vue?vue&type=style&index=0&id=039db22a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039db22a",
  null
  
)

export default component.exports